import React from 'react';

export default function LoadingSpinner() {
  return (
    <section style={{ position: 'relative', top: '50%', left: '50%' }}>
      {/* loading user */}
      <div className='lds-grid'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </section>
  );
}
